import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-angular-validations',
  template: `
    <p>
      angular-validations works!
    </p>
  `,
  styles: [
  ]
})
export class AngularValidationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
